import {
  Box,
  HStack,
  LinkBox,
  LinkOverlay,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import Link from '../../Link';
import { H2, H3, Text } from '../../Text';

type LinkDefinition = {
  href: string;
  heading: string;
  icon: React.ReactElement;
  details: string | React.ReactElement;
};

interface LinksCardProps {
  heading: string;
  links: LinkDefinition[];
}

const LinksCard: React.FC<LinksCardProps> = ({ heading, links }) => {
  const Styles = useMultiStyleConfig('LinksCard', {});
  return (
    <Box sx={Styles.card}>
      <H2 sx={Styles.heading}>{heading}</H2>
      {links.map((link, index) => (
        <LinkBox key={index} sx={Styles.link} as={VStack} spacing={2}>
          <LinkOverlay
            as={Link}
            to={link.href}
            aria-label={link.heading}
            variant="plain"
            isExternal={isExternalLink(link.href)}
          />
          <HStack spacing={4}>
            <Box sx={Styles.icon}>{link.icon}</Box>
            <H3 sx={Styles.linkHeading}>{link.heading}</H3>
          </HStack>
          <Text sx={Styles.details}>{link.details}</Text>
        </LinkBox>
      ))}
    </Box>
  );
};

export default LinksCard;
